<template>
  <page>
    <!-- Keep for further need or enhancement -->
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.cComm_campaign" :label="labels.cComm_campaign" :error-messages="errors.collect('cComm_campaign')" data-vv-name="cComm_campaign" :data-vv-as="labels.cComm_campaign"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <cal-picker :label="labels.cComm_effDate" v-model="filters.cComm_effDate" :error-messages="errors.collect('cComm_effDate')" data-vv-name="cComm_effDate" :data-vv-as="labels.cComm_effDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.cComm_billMths" :label="labels.cComm_billMths" :error-messages="errors.collect('cComm_billMths')" data-vv-name="cComm_billMths" :data-vv-as="labels.cComm_billMths"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Campaign Commission
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.cComm_campaign }}</td>
                <td>{{ formatDisplayDate(row.item.cComm_effDate) }}</td>
                <td>{{ row.item.cComm_billMths }}</td>
                <td>{{ row.item.cComm_commPct }}</td>
                <td>{{ row.item.cComm_protectComm ? 'YES' : 'NO' }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Campaign Commission?
      </confirm>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

// Keep for further need or enhancement
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Campaign Discount',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignDiscList' }
        },
        {
          text: 'Campaign Promotion',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignPromotionList' }
        },
        {
          text: 'Permit Intermediary',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignIntermediaryList' }
        },
        {
          text: 'Promotion',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionList' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Campaign', value: 'cComm_campaign' },
        { text: 'Effective Date', value: 'cComm_effDate' },
        { text: 'No. of Billing Months', value: 'cComm_billMths' },
        { text: 'Commission %', value: 'cComm_commPct' },
        { text: 'Protect Commission', value: 'cComm_protectComm' },
        TableConst.tableActionHeader
      ],
      labels: {
        cComm_campaign: 'Campaign',
        cComm_effDate: 'Effective Date',
        cComm_billMths: 'No. of Billing Months'
      },
      filters: {
        cComm_campaign: undefined,
        cComm_effDate: undefined,
        cComm_billMths: undefined,
        actionKey: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.cComm_effDate) {
            currFilters.cComm_effDate = formatDisplayDateTime2(removeTime(currFilters.cComm_effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  cComm_campaign: datamap.cComm_campaign,
                  cComm_effDate: datamap.cComm_effDate,
                  cComm_billMths: datamap.cComm_billMths,
                  cComm_commPct: datamap.cComm_commPct,
                  cComm_protectComm: datamap.cComm_protectComm,
                  actionKey: datamap.actionKey
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.cComm_campaign = undefined
      this.filters.cComm_effDate = undefined
      this.filters.cComm_billMths = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'campaignCommReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'campaignCommReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'campaignCommReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.doDelete
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    }
  },
  mounted() {
    this.filters.actionKey = 'CAMPAIGN_COMMISSION'
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    // Keep for further need or enhancement
    // SideFunctionMenu
  }
}
</script>
